export const setIsFetching = (state) => {
  return {
    ...state,
    isFetching: true
  }
};

export const filterDataResults = (state, data) => {
  return {
    ...state,
    isFetching: false,
    data: data,
    errorMessage: null
  };
};

export const resetDataResults = (state, message) => {
  return {
    ...state,
    isFetching: false,
    data: [],
    errorMessage: message
  };
};

export const filterIsOpenModal = (state, data) => {
  return {
    ...state,
    isOpenModal: data ? true : false,
    data: data ? data : null,
  };
};

export const updateFundIds = (state, data) => {
  let fundIds = data.length > 0 ? data.map(obj => obj.fundId) : [];
  
  return {
    ...state,
    fundIds: fundIds,
  };
};